import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { Button } from '../../../web/components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../web/components-v2/Dialog';
import { LeadRuleViewModel, LeadRulesViewModel } from '../../viewModels/leadrules';
import { MrryDirection, MrryMessageType, MrryModal } from '../MrryModal';
import { RuleContainerHeader } from './components/RuleContainerHeader';

interface IProps {
	leadRule: LeadRuleViewModel;
	leadRules: LeadRulesViewModel;
	onRequestClose(result?: LeadRuleViewModel, canceled?: boolean): void;
}

interface IMrryState {
	message: string;
	open: boolean;
}

const mrryInitialState: IMrryState = {
	message: null,
	open: false,
};

export const LeadRuleScheduleModal: React.FC<IProps> = observer(({ leadRule, leadRules, onRequestClose }) => {
	const [editableLeadRule, setLeadRule] = useState<LeadRuleViewModel>(null);

	const [showMrry, setMrryState] = useState<IMrryState>(mrryInitialState);

	const userSession = useUserSession();

	useEffect(() => {
		setLeadRule(leadRule ? new LeadRuleViewModel(userSession, toJS(leadRule.getLeadRule)) : null);
	}, [leadRule, userSession]);

	const handleSave = () => {
		editableLeadRule
			.updateSchedule()
			.then(() => {
				leadRule.setLeadRule(editableLeadRule.getLeadRule);

				onRequestClose?.(null, true);
			})
			.catch(error => {
				setMrryState({
					message: error?.systemMessage || 'An error ocurred, please try again.',
					open: true,
				});
			})
			.finally(() => leadRules.sort());
	};

	const handleCloseMrry = () => setMrryState(mrryInitialState);

	return (
		<Dialog open={!!editableLeadRule} onOpenChange={open => !open && onRequestClose?.()}>
			<DialogPopup>
				<DialogHeader>
					<DialogTitle>Edit Schedule</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<RuleContainerHeader leadRule={editableLeadRule} />
					{showMrry.open && (
						<MrryModal
							fromDirection={MrryDirection.FromTop}
							message={{
								content: <p>{showMrry.message}</p>,
								duration: 5000,
								type: MrryMessageType.Error,
							}}
							onRequestClose={handleCloseMrry}
						/>
					)}
				</DialogBody>
				<DialogFooter>
					<Button onClick={handleSave}>Save</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
});
